export const FETCH_FABRIC_REPORT_DATA_REQUEST = 'FETCH_FABRIC_REPORT_DATA_REQUEST';
export const FETCH_FABRIC_REPORT_DATA_SUCCESS = 'FETCH_FABRIC_REPORT_DATA_SUCCESS';
export const FETCH_FABRIC_REPORT_DATA_FAILURE = 'FETCH_FABRIC_REPORT_DATA_FAILURE';

export const CREATE_USER_FORM_FABRIC_REPORTS = 'CREATE_USER_FORM_FABRIC_REPORTS';